import { Container, Grid } from '@material-ui/core'
import { useEffect, useState, useRef } from 'react'
import { ButtonHLPure, TooltipHLPure } from '../../pures'
import LabelPure from '../../pures/label/label.pure'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import TextareaWrapper from '../onboarding/steps/inputs/textareaWrapper'
import { DropDownList } from "@progress/kendo-react-dropdowns"
import { Checkbox } from '@progress/kendo-react-inputs'
import { useTranslation } from 'react-i18next'
import TextAreaWrapper from '../onboarding/steps/inputs/textareaWrapper'
import './chatbot-configuration.css'

const ChatbotCustomizationView = (props) => {
  const {
    initialData,
    saveData,
    assistantTones,
    assistantTonesRaw,
    profileImage: propProfileImage,
    backgroundImage: propBackgroundImage,
    onProfileImageChange,
    onBackgroundImageChange
  } = props

  const { t } = useTranslation('chatbot', { keyPrefix: 'configuration' })
  const { t: tCommon } = useTranslation('common')
  const [tempColor, setTempColor] = useState(initialData.primaryColor)
  const [dropdownSelected, setDropdownSelected] = useState(t(`customization.assistantTone.comboboxTypes.${initialData?.assistantTone}`))
  const profileInputRef = useRef(null)
  const backgroundInputRef = useRef(null)
  const [localProfileImage, setLocalProfileImage] = useState(propProfileImage || null)
  const [localBackgroundImage, setLocalBackgroundImage] = useState(propBackgroundImage || null)

  const [formKey, setFormKey] = useState(1)

  const resetForm = () => setFormKey(formKey + 1)

  
  const triggerProfileInput = () => {
    profileInputRef.current?.click()
  }

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = (event) => {
        setLocalProfileImage(event.target.result)
        if (onProfileImageChange) {
          onProfileImageChange(event.target.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleBackgroundImageChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = (event) => {
        setLocalBackgroundImage(event.target.result)
        if (onBackgroundImageChange) {
          onBackgroundImageChange(event.target.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

    const triggerBackgroundInput = () => {
      backgroundInputRef.current?.click()
    }
    useEffect(() => {
    resetForm()
    //setLocalProfileImage(propProfileImage)
    //setLocalBackgroundImage(propBackgroundImage)
  }, [initialData])
  return (
    <Container maxWidth={'md'}>
      <Form
        key={`chatbot-configuration-${formKey}`}
        initialValues={initialData}
        onSubmit={saveData}
        render={(formRenderProps) => {
          return (
            <FormElement>
              <Grid container spacing={3}>
                {/* Selector de imagen de perfil */}
                <Grid item xs={6} md={6}>
                   <LabelPure title={t('customization.assistantImage')} editorId='assistantImage' />
                  <div className='image-preview-container profile-preview'>
                    <div className='image-preview'>
                      {localProfileImage ? (
                        <img 
                          src={localProfileImage} 
                          alt="Profile Preview" 
                          className='circle-image' 
                          onError={() => setLocalProfileImage(null)}
                        />
                      ) : (
                        <div className='placeholder'>{t('customization.selectProfileImage')}</div>
                      )}
                    </div>
                    <button 
                      onClick={triggerProfileInput} 
                      className="camera-button"
                      aria-label={t('common.changeProfileImage')}
                    >
                     +
                    </button>
                    <input
                      type="file"
                      ref={profileInputRef}
                      onChange={handleProfileImageChange}
                      accept="image/*"
                      className="hidden-input"
                    />
                  </div>
                </Grid>

                {/* Selector de imagen de fondo */}
                <Grid item xs={6} md={6}>
                  <LabelPure title={t('customization.assistantBackgroundImage')} editorId='assistantBackgroundImage' />
                  <div className='image-preview-container background-preview'>
                    <div className='image-preview'>
                      {localBackgroundImage ? (
                        <img 
                          src={localBackgroundImage} 
                          alt="Background Preview" 
                          className='background-image' 
                          onError={() => setLocalBackgroundImage(null)}
                        />
                      ) : (
                        <div className='placeholder'>{t('customization.selectBackgroundImage')}</div>
                      )}
                    </div>
                    <button 
                      onClick={triggerBackgroundInput} 
                      className="camera-button background-button"
                      aria-label={t('common.changeBackgroundImage')}
                    >
                      +
                    </button>
                    <input
                      type="file"
                      ref={backgroundInputRef}
                      onChange={handleBackgroundImageChange}
                      accept="image/*"
                      className="hidden-input"
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id="initialMessage"
                    name={'initialMessage'}
                    component={TextAreaWrapper}
                    label={t("customization.initialMessage")}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <LabelPure title={t('customization.additionalInstructions')} editorId='additionalInstructions' />
                    <TooltipHLPure
                      positionTooltip={'right'}
                      descriptionTooltip={t('customization.tooltipInstructions')}
                      informationIcon
                    />
                  </div>
                  <Field
                    id='additionalInstructions'
                    name={'additionalInstructions'}
                    component={TextareaWrapper}
                    maxLength={10000}
                    rows={4}
                    // validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('customization.assistantTone.title')} editorId='assistantTone' />
                  <Field
                    id='assistantTone'
                    name={'assistantTone'}
                    component={({ onChange: onChangeProps }) => {
                      return (
                        <DropDownList
                          id='assistantTone'
                          name={'assistantTone'}
                          className="eticket-dropdown-field"
                          data={assistantTones}
                          defaultValue={dropdownSelected}
                          onChange={(e) => {
                            const auxTone = assistantTonesRaw.find((assistantTone) => e.target.value === t(`customization.assistantTone.comboboxTypes.${assistantTone.name}`))
                            setDropdownSelected(t(`customization.assistantTone.comboboxTypes.${auxTone.name}`))
                            onChangeProps({ target: { value: e.target.value } })
                          }}
                        />
                      )
                    }}
                    // validator={requiredValidator}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('customization.colorPicker')} editorId='colorPicker' />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Field
                      name='primaryColor'
                      component={({ onChange }) => {
                        return (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type='color'
                              defaultValue={tempColor}
                              onBlur={(e) => {
                                onChange({ target: { value: e.target.value } })
                                setTempColor(e.target.value)
                                console.log(e.target.value)
                              }}
                              style={{
                                width: '36px',
                                height: '36px',
                                padding: 0,
                                border: '1px solid #ccc',
                                borderRadius: '4px'
                              }}
                            />
                          </div>
                        );
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <Field
                    id='sendAttachment'
                    name={'sendAttachment'}
                    component={Checkbox}
                    label={t('customization.sendAttachment')}
                  />
                </Grid>
                <Grid item xs={12} className='button-actions'>
                  {
                    formRenderProps.modified &&
                    <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('cancel')} onClick={() => {
                      resetForm()
                      setTempColor(initialData.primaryColor)
                    }} />
                  }
                  <ButtonHLPure primary nameBtn={tCommon('save')} type='submit' />
                </Grid>
              </Grid>
            </FormElement>
          )
        }}
      />
    </Container>
  )
}

export default ChatbotCustomizationView